<template>
	<div class="box">
		<div v-if="imgKey" class="preview-box" :style="{ height, width,borderRadius:round+'%' }">
			<el-image ref="preview" class="preview" fit="contain" :src="imgSrc" :preview-src-list="[imgSrc]"></el-image>
			<div class="operation">
				<i class="el-icon-zoom-in" @click="$refs.preview.clickHandler()"></i> <i class="el-icon-delete" @click="$emit('change','')"></i>
			</div>
		</div>
		<div v-else v-loading="loading" class="add-btn" :style="{ height, width ,borderRadius:round+'%'}" @click="select">
			<i class="icon el-icon-plus"></i>
		</div>
		<input ref="imageInput" hidden type="file" accept="image/*" />
	</div>
</template>

<script>
	export default {

		model: {
			prop: "imgKey",
			event: "change"
		},

		props: {
			width: {
				type: String,
				default: "150px"
			},
			height: {
				type: String,
				default: "150px"
			},
			imgKey: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: 'key'
			},
			round:{
				type: String,
				default:'0'
			}
		},

		data() {
			return {
				loading: false
			};
		},

		computed: {
			imgSrc() {
				return this.type === 'key' ? 'https://vybbasevr.vyb.cn/' + this.imgKey : this.imgKey
			},
		},

		methods: {

			select() {
				let input = this.$refs.imageInput;
				input.click();
				input.onchange = e => {
					let files = e.target.files;
					this.doUpload(files);
				};
			},

			//上传文件
			async doUpload(files) {
				this.loading = true;
				try {
					let res = await this.utils.upload.uploadFiles(files, {bucket: "vybbasevr"});
					this.$emit("change", this.type === 'key' ? res[0].key : res[0].preview);
				} catch (e) {
					console.error(e);
				}
				this.$refs.imageInput.value = "";
				this.loading = false;
			}
		}
	};
</script>

<style scoped>
	.box {
		line-height: 0;
	}

	.add-btn {
		border-radius: 4px;
		border: 1px dashed #999;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.preview-box {
		display: inline-flex;
		position: relative;
		border: 1px solid #fff;
		background: #ddd;
		min-width: 100px;
		min-height: 100px;
		align-items: center;
	}

	.preview {
		position: absolute;
		top: 2px;
		bottom: 2px;
		left: 2px;
		right: 2px;
	}

	.preview-box .operation {
		position: absolute;
		width: 100%;
		height: 100%;
		color: #fff;
		top: 0;
		left: 0;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		opacity: 0;
		transition: all 0.3s ease-in-out;
	}

	.preview-box:hover .operation {
		opacity: 1;
	}

	.preview-box .operation i {
		cursor: pointer;
		font-size: 18px;
		margin-right: 15px;
	}

	.preview-box .operation i:last-child {
		margin-right: 0;
	}

</style>
